var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63967 7.84866C6.70146 7.78637 6.75034 7.71249 6.78352 7.63126C6.8167 7.55004 6.83352 7.46306 6.83301 7.37533V4.70866C6.83301 4.53185 6.76277 4.36228 6.63775 4.23725C6.51272 4.11223 6.34315 4.04199 6.16634 4.04199H3.49967C3.32286 4.04199 3.15329 4.11223 3.02827 4.23725C2.90325 4.36228 2.83301 4.53185 2.83301 4.70866C2.83301 7.71445 4.02705 10.5971 6.15246 12.7225C8.27788 14.8479 11.1606 16.042 14.1663 16.042C14.3432 16.042 14.5127 15.9718 14.6377 15.8467C14.7628 15.7217 14.833 15.5521 14.833 15.3753V12.7087C14.833 12.5318 14.7628 12.3623 14.6377 12.2373C14.5127 12.1122 14.3432 12.042 14.1663 12.042H11.4997C11.4119 12.0415 11.325 12.0583 11.2437 12.0915C11.1625 12.1247 11.0886 12.1735 11.0263 12.2353L9.69301 13.5687L9.64634 13.6287C7.75289 12.662 6.21302 11.1221 5.24634 9.22866L5.30634 9.18199L6.63967 7.84866ZM11.773 13.3753H13.4997V14.7087C12.6369 14.65 11.7853 14.4797 10.9663 14.202L11.773 13.3753ZM4.69301 7.90866C4.40848 7.09059 4.23144 6.23901 4.16634 5.37533H5.49967V7.10199L4.69301 7.90866Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.aea9aa7b0a63b88d055e409d289b170c.svg";
export { ForwardRef as ReactComponent };